import { render, staticRenderFns } from "./edit-faq-category.vue?vue&type=template&id=6cf366ad&"
import script from "./edit-faq-category.vue?vue&type=script&lang=js&"
export * from "./edit-faq-category.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports